import {clsx} from 'clsx'
import type {DisclosurePanelProps} from '../disclosure/DisclosurePanel'
import type {ReactNode} from 'react'
import {DisclosurePanel} from '../disclosure/DisclosurePanel'
import styles from './Accordion.module.css'

/**
 * `labelledBy` is always on, so the panel is a `role="region"` labelled by its header trigger.
 */
export type AccordionPanelProps = Omit<DisclosurePanelProps, 'children' | 'labelledBy'> & {
  children: ReactNode
}

/**
 * Visibility, animation, `hidden="until-found"`, `beforematch`, SSR reveal and ARIA wiring all
 * belong to `Disclosure.Panel`. This wrapper only adds presentation.
 */
export const AccordionPanel = ({className, children, ...rest}: AccordionPanelProps) => (
  <DisclosurePanel {...rest} labelledBy className={clsx(styles.PanelContent, className)}>
    {children}
  </DisclosurePanel>
)

AccordionPanel.displayName = 'Accordion.Panel'
